export const GiftCardIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.66669 6.66667H13.3334V12C13.3334 12.1768 13.2631 12.3464 13.1381 12.4714C13.0131 12.5964 12.8435 12.6667 12.6667 12.6667H3.33335C3.15654 12.6667 2.98697 12.5964 2.86195 12.4714C2.73693 12.3464 2.66669 12.1768 2.66669 12V6.66667Z"
            stroke="#FF9900"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.33331 2C5.90688 2.09154 6.44948 2.32151 6.91414 2.67001C7.3788 3.0185 7.7515 3.47501 7.99998 4"
            stroke="#FF9900"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.6667 2C10.0931 2.09154 9.5505 2.32151 9.08584 2.67001C8.62118 3.0185 8.24848 3.47501 8 4"
            stroke="#FF9900"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 12.6667V4M13.3333 6.66667H2.66667C2.48986 6.66667 2.32029 6.59643 2.19526 6.4714C2.07024 6.34638 2 6.17681 2 6V4.66667C2 4.48986 2.07024 4.32029 2.19526 4.19526C2.32029 4.07024 2.48986 4 2.66667 4H13.3333C13.5101 4 13.6797 4.07024 13.8047 4.19526C13.9298 4.32029 14 4.48986 14 4.66667V6C14 6.17681 13.9298 6.34638 13.8047 6.4714C13.6797 6.59643 13.5101 6.66667 13.3333 6.66667Z"
            stroke="#FF9900"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
